import { KOBOO_LIGHT_GREY } from './colors';
import { DEFAULT_MARGIN } from './stylesDefault';

const styles = {
  round: {
    borderRadius: '2em',
    width: '220px',
    display: 'flex',
    flexDirection: 'row',
    padding: '4px 16px',
    marginTop: DEFAULT_MARGIN,
    marginBottom: DEFAULT_MARGIN,
    backgroundColor: KOBOO_LIGHT_GREY,
  },
  helperText: {
    position: 'absolute',
    bottom: '-19px',
    left: '-8px',
    width: '237px',
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/constants/KobooRoundInput.css.js